<div *ngIf="loading" class="loading-indicator">
  <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
</div>


<div class="container" appDnd (fileDropped)="onFileDropped($event)" *ngIf="parentFolderId == undefined">

  <!-- <input type="file" class="msTeam-btn" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)" /> -->

  <!-- <img src="assets/ic_upload_final_white.svg" width="90" alt=""> -->
  <div class="uploadIcon" alt=""></div>
  <h4>{{dragAndDrop}}</h4>
  <h4>{{or}}</h4>
  <!-- <button mat-raised-button class="msTeam-btn" style="margin-left: 0px;">{{browseForFile}}</button> -->
  <button mat-raised-button class="msTeam-btn" style="margin-left: 0px;" for="fileDropRef">{{browseForFile}}
    <input type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)" />
  </button>
</div>

<div *ngIf=isShare style="padding-left: 15px; padding-right: 15px;">
  <sharesettings-dialog #shareSettingsDialog></sharesettings-dialog>
</div>
<div class="vhcenter">
<div *ngIf=isDuplicate  class="deduplication-screen">
  <duplicate-dialog #duplicateDialog (handleDuplicateFileSaveEvent)="duplicateFileSaveEvent($event)"></duplicate-dialog>
</div>
</div>


<div class="files-list" *ngIf="!isShare && files.length > 0">
  <h2 mat-dialog-title style="padding-bottom: 0px; margin-bottom: 0px; font-size:17px;"
    *ngIf="parentFolderId != undefined && location != undefined" id="fileLocation" class="primary-color">
    {{uploadFileLoc}} {{location}}</h2>
  <div class="single-file" *ngFor="let file of files; let i = index" style="margin-top: 8px;  margin-bottom: 10px;">
    <img src="./assets/{{getFileIcon()}}_icon.svg" width="35px" alt="file" style="padding-right:10px;">
    <div class="full-width overflowHidden">
      <h3 class="name">
        {{ file?.name}}
      </h3>
      <p class="size">
        {{ formatBytes(file?.size) }}
      </p>

      <p aria-live class="error" [hidden]=" uploadStatus != SYNC_STATUS_FAIL">
        {{uploadFailMessage}}
      </p>
      <mat-progress-bar mode="indeterminate"
        *ngIf="uploadStatus != SYNC_STATUS_DONE && uploadStatus != SYNC_STATUS_FAIL"></mat-progress-bar>
      <app-progress [progress]="100" *ngIf="uploadStatus == SYNC_STATUS_DONE" class="progresstruncate"></app-progress>
    </div>
    <div class="uploadDone" id="icUploadDone" [hidden]="uploadStatus != SYNC_STATUS_DONE"></div>

    <!-- <img src="assets/success2.svg" class="delete" id="icUploadDone" width="20px" alt="file"
      [hidden]="uploadStatus != SYNC_STATUS_DONE">
 -->
  </div>
  <div class="uploadshare">
    <div *ngIf="uploadStatus == SYNC_STATUS_DONE" class="uploadsharelinkdesc">
      <!-- <div *ngIf="uploadStatus == SYNC_STATUS_DONE" style="color: #353f4a; float: left;"> -->
      {{shareLinkDesc}}
    </div>
    <div style="flex: 1;"></div>
    <button mat-raised-button id="share_btn" *ngIf="uploadStatus == SYNC_STATUS_DONE" style=" min-width:88px; 
      max-height:40px;" class="cancelBtn" (click)="handleShareItem()">{{shareLink}}</button>
  </div>
</div>


<div class="global-footer add-divider" style=" position: absolute; bottom: 0; left: 0; right: 0;" *ngIf=!isShare>

  <div class="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading"
    style="margin-top: 10px;"></div>

  <div class="msTeam-modal-footerdialog" style="margin-bottom: 6px;">
    <button mat-raised-button style="margin-right:10px;" (click)="closeUploadView()" class="cancelBtn"
      *ngIf="!isShare && uploadStatus != SYNC_STATUS_DONE">{{cancel}}</button>

    <button id="upload_btn" *ngIf=isDuplicate class="msTeam-btn" mat-raised-button [disabled]="!enableUploadButton"
      style="margin-left:10px; margin-right: 10px;" (click)="UploadDuplicateFile()">
      {{uploadToHQ}}
    </button>

    <button mat-raised-button class="msTeam-btn" style="margin-right:10px; margin-top: 0px; "
      (click)="closeUploadView()" *ngIf="!isShare && uploadStatus == SYNC_STATUS_DONE">{{done}}</button>
    <button mat-raised-button id="upload_again" class="msTeam-btn" *ngIf="uploadStatus == SYNC_STATUS_FAIL"
      style="margin-left:4px;margin-right: 10px;" (click)="uploadAgain()">{{uploadAnother}}</button>
  </div>
</div>